import React, { useState, useEffect } from 'react';
import { func, string } from 'prop-types';
import {
  Button,
  Typography,
} from '@material-ui/core';

import { withMeetingContext, MeetingContextDevicePermissionsProps } from 'Scenes/_root/meetingContext';
import styles from './styles.scss';

const getColorFromPermission = (permission) => {
  switch (permission) {
    case 'denied': return 'error';
    case 'prompt': return 'textPrimary';
    case 'granted':
    default:
      return 'primary';
  }
};

export const PermissionStatus = ({
  registerMeetingCallbacks,
  devicePermissions,
  permissionName,
}) => {
  const [permission, setPermission] = useState('granted');

  const updatePermission = () => {
    setPermission(devicePermissions.getDevicePermissions()[permissionName]);
  };

  useEffect(() => {
    updatePermission();
    return registerMeetingCallbacks(`permissionStatus-${permissionName}`, {
      onDevicePermissionChange: updatePermission,
    });
  }, []);

  return (
    <div className={styles.permissionStatus}>
      <Typography
        variant='body1'
      >
        <strong>{permissionName}</strong> permission is
      </Typography>
      <Typography
        color={getColorFromPermission(permission)}
        variant='body1'
      >
        <strong>&nbsp;{permission}</strong>
      </Typography>
      <div className={styles.grow} />
      {
        permission === 'prompt' && (
          <Button
            color='primary'
            onClick={() => {
              devicePermissions.prompt(permissionName);
            }}
            type='button'
            variant='contained'
          >
            Request permission
          </Button>
        )
      }
    </div>
  );
};

PermissionStatus.propTypes = {
  permissionName: string.isRequired,
  registerMeetingCallbacks: func.isRequired,
  devicePermissions: MeetingContextDevicePermissionsProps,
};

export default withMeetingContext(['registerMeetingCallbacks', 'devicePermissions'])(PermissionStatus);
